module.exports = __webpack_public_path__ + "static/media/Yoyo_8440.369b1989.jpg";